class CaskPortfolio extends HTMLElement {
  constructor() {
    super();
    this.handleLoadMore = this.handleLoadMore.bind(this);
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get sectionsToUpdate() {
    return this.dataset.sectionsToUpdate
      ? this.dataset.sectionsToUpdate.split(",").map((s) => `.${s.trim()}`)
      : [];
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.loadMore = this.querySelector(
      ".bosYouCaskPortfolioOrderLoadMoreButton",
    );
    if (this.loadMore) {
      this.loadMore.addEventListener("click", this.handleLoadMore);
    }
  }

  handleLoadMore(e) {
    e.preventDefault();
    const target = e.currentTarget;

    if (target && this.sectionId) {
      const newUrl = target.href;
      const url = new URL(newUrl);
      url.searchParams.set("sections", this.sectionId);

      this.fetchUpdatedContent(url);
    }
  }

  fetchUpdatedContent(url) {
    fetch(url.toString())
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.renderSection(data[this.sectionId]);

        // rebind listener
        this.bindEvents();
      })
      .catch((err) => console.error(err));
  }

  renderSection(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    const selectors = this.sectionsToUpdate;

    selectors.forEach((selector) => {
      const target = document.querySelector(selector);
      const source = temp.querySelector(selector);

      if (!target || !source) return;

      // add to end of other articles
      if (selector === ".bosYouCaskPortfolioOrderTileContainer") {
        target.insertAdjacentHTML("beforeend", source.innerHTML);
        return;
      }

      // else just update
      target.innerHTML = source.innerHTML;
    });
  }
}

if (!customElements.get("cask-portfolio")) {
  customElements.define("cask-portfolio", CaskPortfolio);
}
